import "~/application.js";

Turbo.session.drive = false;
